import React from "react";

import { Button, CheckCircleIcon } from "shared/ui";

import { Action, Card, Note, Text, Title, Value } from "./styles";

interface CompletedStepRowProps {
    title: string;
    value: string;
    mono?: boolean;
    note?: string;
    onEdit: () => void;
}

export const CompletedStepRow = ({ title, value, mono, note, onEdit }: CompletedStepRowProps) => (
    <Card>
        <CheckCircleIcon />

        <Text>
            <Title>{title}</Title>
            <Value $mono={mono}>{value}</Value>
        </Text>

        {note && <Note>{note}</Note>}

        <Action>
            <Button variant="text" size="small" onClick={onEdit}>
                Изменить
            </Button>
        </Action>
    </Card>
);
